
















import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import AnalysisItem from "../analysis-item/AnalysisItem.vue";
import { Analysis } from "@/api/analyses/types";
import AgroIcon from '@/components/agroIcons/AgroIcons.vue';
import AnalysesListSection from './AnalysesListSection.vue'

@Component({
  name: "AnalysesList",
  components: {
    AnalysisItem,
    AgroIcon,
    AnalysesListSection,
  }
})
export default class AnalysesList extends Vue {
  @Prop({ type: Array, required: true })
  private analysesList!: Analysis[];

  get sortedAnalysesList() {
    return this.analysesList.flat().sort((a, b) => (a.createdAt! === b.createdAt!) ? 0 :((a.createdAt! > b.createdAt!) ? -1 : 1));
  }

  private get analiticaAnalyses(): Analysis[] {
    return this.sortedAnalysesList.filter(a => a.isAnalitica());
  }

  private get sentinelaAnalyses(): Analysis[] {
    return this.sortedAnalysesList.filter(a => a.isSentinela());
  }

  @Emit('analysis:delete')
  private analysisDeleted(analysis: Analysis) {}

  @Emit('analysis:create')
  private createAnalysis(analysisType: string) {}
}
